import { render, staticRenderFns } from "./EditShares.vue?vue&type=template&id=3df1fe4e&"
import script from "./EditShares.vue?vue&type=script&lang=ts&"
export * from "./EditShares.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports